<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout wrap>
        <v-flex lg12 md12 xs12>
          <v-card elevation="0" min-height="500">
            <v-card-title>{{$t('Settings.StaffUsersList.StaffUsers')}}
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                class="mr-5"
                hide-details
                :label="$t('GeneralTranslations.Search')"
                single-line
              ></v-text-field>

              <v-btn
                v-if="user.accessLevel === 'Org Admin'"
                class="primary mr-5"
                @click="openManageRolesDialog"
              >
                
                {{$t('Settings.StaffUsersList.ManageRoles')}}
              </v-btn>

              <v-btn
                v-if="user.accessLevel === 'Org Admin'"
                class="primary mr-5"
                @click="openUserAddRoleDialog"
              >
                
                {{$t('Settings.StaffUsersList.AddRole')}}

              </v-btn>

              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="primary" :disabled="isFacilityUser || isFacilityAdmin" v-bind="attrs" v-on="on"
                    >{{$t('Settings.StaffUsersList.AddUser')}}</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{$t('Settings.StaffUsersList.CreateUser')}}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container class="p-0">
                      <validation-observer ref="observer" v-slot="{ invalid }">
                        <v-form
                          ref="createUserForm"
                          lazy-validation
                          id="create-user-form"
                          @submit.prevent="submit"
                        >
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Name"
                              rules="required"
                            >
                              <v-text-field
                                v-model="form.name"
                                :label="$t('Settings.StaffUsersList.Name')+'*'"
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Email"
                              rules="required|email"
                            >
                              <v-text-field
                                v-model="form.email"
                                :label="$t('Settings.StaffUsersList.EmailAddress')+'*'"
                                :error-messages="errors"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="FacilityAccess"
                              rules="required"
                            >
                              <v-select
                                v-model="form.facilities"
                                :items="facilitiesForOrg"
                                :error-messages="errors"
                                item-text="name"
                                :label="$t('Settings.StaffUsersList.FacilityAccess')+'*'"
                                multiple
                                required
                                return-object
                              ></v-select>
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="AccessLevel"
                              rules="required"
                            >
                              <v-select
                                v-model="form.accessLevel"
                                :items="staffAccessLevels"
                                :error-messages="errors"
                                :label="$t('Settings.StaffUsersList.AccessLevel')+'*'"
                                required
                              ></v-select>
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Role"
                              rules=""
                            >
                              <v-select
                                class="autofocus"
                                v-model="form.roles"
                                :items="usersRoles"
                                item-text="name"
                                :label="$t('Settings.StaffUsersList.Role')"
                                :error-messages="errors"
                                required
                                multiple
                              ></v-select>
                            </validation-provider>
                          </v-col>

                          <v-col
                            cols="12"
                            v-if="!isStaffUserInviteEmailTemplateExists"
                          >
                            <v-alert dense outlined color="error">
                              <v-row align="center">
                                <v-col cols="8" class="text-subtitle-2">
                                  {{$t('Settings.StaffUsersList.EmailTemplateWithType')}}
                                  {{$t('Settings.StaffUsersList.MissingStaffUserInviteText')}}
                                </v-col>
                                <v-col>
                                  <router-link
                                    @click.native="dialog = false"
                                    class="text-decoration-none"
                                    to="/settings?tab=emailTemplates"
                                    ><v-btn color="primary" block>
                                      {{$t('GeneralTranslations.Create')}}</v-btn
                                    ></router-link
                                  >
                                </v-col>
                              </v-row>
                            </v-alert>
                          </v-col>

                          <v-col cols="12">
                            <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
                          </v-col>

                          <v-col cols="12">
                            <div class="d-flex">
                              <v-spacer></v-spacer>
                              <v-btn
                                color="error"
                                text
                                class="mr-4"
                                @click="cancel"
                                >{{$t('GeneralTranslations.Cancel')}}</v-btn
                              >
                              <v-btn
                                color="primary"
                                :disabled="
                                  invalid ||
                                    submited ||
                                    !isStaffUserInviteEmailTemplateExists
                                "
                                :loading="submited"
                                type="submit"
                                >
                                {{$t('Settings.StaffUsersList.CreateUser')}}
                                </v-btn>
                            </div>
                          </v-col>
                        </v-form>
                      </validation-observer>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <!-- <v-btn v-if="user.accessLevel === 'Org Admin'" class="primary ml-5" @click="openUserInvitesDialog">
                Send User Invites
              </v-btn> -->
            </v-card-title>


            <v-data-table
              :headers="headers"
              :items="facilityUsers"
              :search="search"
              @click:row="handleClickUser"
            >
              <template v-slot:item.profilePicUrl="{ item }">
                <v-avatar class="mt-3 mb-3" size="50px">
                  <img :src="item.profilePicUrl" alt />
                </v-avatar>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <FacilityUsersRolesDialog v-if="user.accessLevel === accessLevelsEnum.OrgAdmin" ref="facilityUsersRolesDialog"/>

    <FacilityUserAddRoleDialog v-if="user.accessLevel === accessLevelsEnum.OrgAdmin" ref="facilityUserAddRoleDialog"/>

    <InviteUsersDialog v-if="user.accessLevel === accessLevelsEnum.OrgAdmin" ref="inviteUsersDialogRef"/>

    <v-divider></v-divider>
  </v-card>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import * as firebase from "firebase/app";
  import "firebase/firestore";
  import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import { DEFAULT_AVATAR_BLACK } from "@/consts/default-avatar";
  import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
  import { getRegionName } from "@/utils/functionsRegion";
  import FacilityUsersRolesDialog
    from "@/views/settings/facility/facility-users-roles-dialog/FacilityUsersRolesDialog.vue";
  import FacilityUserAddRoleDialog
    from "@/views/settings/facility/facility-users-add-role-dialog/FacilityUserAddRoleDialog.vue";

  import InviteUsersDialog from "@/views/settings/facility/users-invitation/InviteUsersDialog.vue";

  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
      FacilityUsersRolesDialog,
      FacilityUserAddRoleDialog,
      InviteUsersDialog
    },
    name: "StaffUsersList",
    computed: {
      ...mapGetters({
        user: "user"
      }),
      ...mapState({
        facility: state => state.facilityModule.selectedFacility,
        facilityUsers: state => state.facilityModule.selectedFacilityUsers,
        facilitiesForOrg: state => state.userModule.facilitiesForOrg,
        emailTemplates: state => state.facilityModule.facilityEmailTemplates,
        currentUser: state => state.authModule.user
      }),
      staffAccessLevels() {
        if(this.facility?.isEnabledStaffAPI === true) {
          return [StaffAccessLevels.MaintenanceAdmin, StaffAccessLevels.MaintenanceUser]
        }

        return Object.values(StaffAccessLevels);
      },
      isStaffUserInviteEmailTemplateExists() {
        return (
          this.emailTemplates.filter(
            emailTemplate =>
              emailTemplate.type === DefaultEmailTemplateType.StaffUserInvite
          ).length > 0
        );
      },
      usersRoles() {
        return this.$store.state.userModule.usersRoles;
      },
      isFacilityUser() {
        return this.currentUser.accessLevel === this.accessLevelsEnum.FacilityUser;
      },
      isFacilityAdmin() {
        return this.currentUser.accessLevel === this.accessLevelsEnum.FacilityAdmin;
      },
    },
    data() {
      return {
        search: "",
        dialog: false,
        accessLevelsEnum: StaffAccessLevels,
        headers: [
          {
            text: "",
            align: "",
            sortable: false,
            width: 70,
            value: "profilePicUrl"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
            align: "start",
            sortable: false,
            value: "name"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['Settings.StaffUsersList.AccessLevel'],
            align: "start",
            sortable: false,
            value: "accessLevel"
          },
          {
            text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Email'],
            align: "start",
            sortable: false,
            value: "email"
          }
        ],
        form: {
          name: "",
          email: "",
          facilities: [],
          accessLevel: "",
          roles: [],
          rolesIds: [],
        },
        submited: false
      };
    },
    mounted() {
      this.$store.dispatch("getOrgUsers", this.user.orgId);
      this.$store.dispatch("getFacilitiesForOrg");
      this.$store.dispatch("getFacilityEmailTemplates");
      this.$store.dispatch("getMaintenanceCategories");
    },
    methods: {
      handleClickUser(row) {
        this.$router.push("/settings/users/" + row.id);
      },
      async submit() {

        if (this.submited == true) return true

        this.submited = true;

        const isValidEmail = await this.validateEmail(this.form.email);

        if (!isValidEmail) {
          this.$refs.observer.setErrors({
            Email: [this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.EmailAlreadyExists']]
          });

          this.submited = false;

          return;
        }

        const facilities = this.form.facilities.map(facility => ({
          id: facility.id,
          name: facility.name
        }));

        const facilitiesIds = this.form.facilities.map(facility => facility.id);
        const facility = this.form.facilities[0];

        const user = {
          ...this.form,
          facilityId: facility.id,
          regionId: facility.regionId,
          orgId: facility.orgId,
          facilities,
          facilitiesIds,
          profilePicUrl: DEFAULT_AVATAR_BLACK
        };

        if(this.form.roles?.length) {
          const rolesIds = this.form.roles.map(roleName => {
            const role = this.usersRoles.find(x => x.name === roleName);
            if(role) {
              return role.id;
            }
          });

          user.rolesIds = rolesIds;
        } else {
          delete user.roles;
        }

         await this.$store.dispatch("createNewFacilityUser", {
           user,
           orgId: facility.orgId
         }).finally(() => {
           this.submited = false;
           this.resetForm()
         });

        this.dialog = false;
      },
      resetForm(){
        this.form.name = ""
        this.form.email = ""
        this.form.facilities = []
        this.form.accessLevel = ""
        this.form.roles = ""
        this.$refs.createUserForm.reset();
        this.$refs.observer.reset();
      },
      cancel() {
        this.dialog = false;
        this.resetForm()
      },
      async validateEmail(email) {

        const result = await firebase.app().functions(getRegionName())
          .httpsCallable("checkIfEmailExists")({
          emailAddress: email,
          orgId: this.facility.orgId
        });

        if (result.data.data.number > 0) {
          return false;
        }

        return true;
      },
      openManageRolesDialog() {
        this.$refs.facilityUsersRolesDialog.open();
      },
      openUserAddRoleDialog() {
        this.$refs.facilityUserAddRoleDialog.open();
      },
      openUserInvitesDialog() {
        this.$refs.inviteUsersDialogRef.open(this.facility.id, this.facility.orgId);
      }
    }
  };
</script>

<style lang="scss">
  .v-application #user-management {
    .v-card {
      box-shadow: none !important;
    }
  }
</style>
